import { useState } from "react";
import { useMemberGuideList } from "../../../../../hooks/manageMembers/useMemberGuideList";
import { toAbsoluteUrl } from "../../../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../../../utils/constants";
import { ApiMember } from "../../../../manageMembers/models/ManageMemberModel";

type Props = {
    value: ApiMember | null;
    onChange: (value: ApiMember | null) => void;
}


export const ProfileMemberGuideInput = ({ value, onChange }: Props) => {
    const [search, setSearch] = useState("");
    const [showOpts, setShowOpts] = useState(false);
    const { loading, list, reset } = useMemberGuideList(search); 

    const _handleSelect = (value: ApiMember | null) => {
        onChange(value);
        if(!value)
            return;
        setSearch("");
        reset();
    }

    return (
        <div className="nb-pmg__input-group-wrap">
            <div className="nb-pmg__input-group">
                <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.5 17.5L13.875 13.875" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </i>
                {value && (
                    <div className="nb-pmg__value">
                        <img src={toAbsoluteUrl(value.profilePicture) } onError={(e) => { e.currentTarget.src = defaultProfileImage }} />
                        <span>{`${value.firstName} ${value.lastName}`}</span>
                        <button onClick={() => _handleSelect(null)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M10.9375 3.0625L3.0625 10.9375" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10.9375 10.9375L3.0625 3.0625" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                )}
                <input 
                    type="text" 
                    placeholder="Select Member"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    onFocus={() => setShowOpts(true)}
                    onBlur={() => setShowOpts(false)}
                />
            </div>
            {showOpts &&  (
                <div className="nb-pmg__options">
                    {loading && <span>Loading...</span>}
                    {list.length > 0 && (
                        <>
                            {list.map((o, i) => (
                                <button
                                    type="button"
                                    key={i}
                                    onPointerDown={() => _handleSelect(o)}
                                    onMouseDown={() => _handleSelect(o)}
                                >
                                    <img src={toAbsoluteUrl(o.profilePicture) } onError={(e) => { e.currentTarget.src = defaultProfileImage }} />
                                    {`${o.firstName} ${o.lastName}`}
                                </button>
                            ))}
                        </>
                    )}
                </div>
            )}
        </div>
    )
}